import {
    CONSULTINGCHECKIMEI,
    CONSULTINGCHECKIMEI_ERROR,
    CLEAN_CONSULTINGCHECKIMEI,
    CLEAN_CONSULTINGCHECKIMEI_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CONSULTINGCHECKIMEI:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case CONSULTINGCHECKIMEI_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };
        case CLEAN_CONSULTINGCHECKIMEI:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_CONSULTINGCHECKIMEI_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
